import { Loading } from 'src/components';
import ModalBody from 'src/components/Modal/body';
import i18n from 'src/i18n';

import { SchedulePostForm } from '../SchedulePostForm';
import { ShowSchedulePostsButton } from '../ShowSchedulePostsButton';
import SchedulePostModalFooter from './schedulePostModalFooter';
import SchedulePostModalHeader from './schedulePostModalHeader';

type SchedulePostModalFormProps = {
  formId: string;
  formIsInvalid: boolean;
  isLoadingScheduledPosts: boolean;
  scheduledPostsReqHasError: boolean;
  isScheduleFormSaved: boolean;
  handleGoBack: () => void;
  handleShowList: () => void;
  handleClear: () => void;
  handleSubmit: () => void;
  hasScheduledPosts?: boolean;
};

const SchedulePostModalForm = ({
  formId,
  formIsInvalid,
  isLoadingScheduledPosts,
  scheduledPostsReqHasError,
  isScheduleFormSaved,
  handleGoBack,
  handleShowList,
  handleClear,
  handleSubmit,
  hasScheduledPosts
}: SchedulePostModalFormProps) => {
  return (
    <>
      <SchedulePostModalHeader
        label={i18n.t('modals.schedule_posts.title')}
        handleGoBack={handleGoBack}
      />

      <ModalBody className="_px-5 _pb-5 _pt-0 _text-break">
        <SchedulePostForm id={formId} />

        {isLoadingScheduledPosts && !scheduledPostsReqHasError ? (
          <div className="_w-full _d-flex _align-items-center _justify-content-center">
            <Loading />
          </div>
        ) : null}

        {hasScheduledPosts ? <ShowSchedulePostsButton onClick={handleShowList} /> : null}
      </ModalBody>

      <SchedulePostModalFooter
        isDisabledClearForm={!isScheduleFormSaved}
        formId={formId}
        formIsInvalid={formIsInvalid}
        handleClear={handleClear}
        handleGoBack={handleGoBack}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default SchedulePostModalForm;
